/** модальное окно для выбора локализаций в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { FloatModal } from "components/special";

const { api } = adminAPI.actions;

const FloatAdvertisersModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="Advertisers" />}
      {...props}
      head={(search, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(advertiser, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!advertiser.enabled ? "text-strike" : ""}>
            {advertiser.name}
          </td>

          <td></td>
        </>
      )}
    />
  );
};

const FloatAdvertisers = (props) => {
  return <FloatAdvertisersModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/advertisers"),
})(FloatAdvertisers);
